import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e9cb535"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_modal_wrap" }
const _hoisted_2 = { class: "modal_place_input" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal_place_input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "modal_place_input_mark" }, "*"),
  /*#__PURE__*/_createTextVNode(" 临时账号授权管理 ")
], -1))
const _hoisted_4 = { class: "modal_place_input_content" }

import { withDefaults, watch, ref, computed } from 'vue';

// test
import type { SubAcForm } from '../List.vue';
interface Option {
  label: string;
  value: string;
}
interface IProps {
  modelValue: SubAcForm;
  sourceData: Option[];
}

const __default__ = { name: 'ModalSubAuto' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: { default: {
    childList: [],
  } },
    sourceData: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as { modelValue: SubAcForm, sourceData: Option[] };

const subList = ref<Option[]>([]);

// test

const form = ref(props.modelValue);
const childOptions = computed(() => props.sourceData);

watch(
  () => props.modelValue,
  () => {
    form.value = props.modelValue;
  }
);
watch(form.value, (newVal) => {
  emit('update:modelValue', newVal);
});

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_a_select, {
          value: form.value.childList,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.childList) = $event)),
          options: _unref(childOptions),
          mode: "tags",
          placeholder: "请选择",
          style: {"min-width":"200px"}
        }, null, 8, ["value", "options"])
      ])
    ])
  ]))
}
}

})